import React, { useState, useEffect } from "react";
import { Table } from "../../components/Table/Table";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar/Topbar";
import { CaretLeft } from "../../assets/img";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import moment from "moment";

export default function FailedNotificationDetails() {
  const { paginationData, setpaginationData } = useGlobalContext();
  const { state } = useLocation();
  const id = state?.id;
  const [pagination, setPagination] = useState({});
  const [name, setName] = useState({});
  const [page, setPage] = useState(1);
  const [note, setNote] = useState("");
  const [transactionData, setTransactonData] = useState({});

  const navigate = useNavigate();

  useEffect(() => {
    let userName = JSON.parse(localStorage.getItem("admin_details"));
    setName(userName);
    getList();
  }, []);

  const getList = async () => {
    let res = await get(`${URLS.PAYMENT_FAILED_LIST}${id}/`);
    console.log("failed list view", res);
    if (res?.status === "success") {
      setNote(res?.data?.notes);
      setTransactonData(res?.data);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          const pageSize = 10;
          return (
            <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
              <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>
            </div>
          );
        },
      },
      {
        Header: "Transaction ID",
        accessor: "razorpay_order_id",
        Cell: ({ value }) => (
          <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
            <p>{value}</p>
          </div>
        ),
      },
      {
        Header: "Amount",
        accessor: "paid_amount",
        Cell: ({ value }) => (
          <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
            <p>{value}</p>
          </div>
        ),
      },
      {
        Header: "Date",
        accessor: "created_At",
        Cell: ({ value }) => (
          <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
            <p>{moment(value).format("DD-MM-YYYY hh:mm A")}</p>
          </div>
        ),
      },
      {
        Header: "Payment Type",
        accessor: "payment_gateway_name",
        Cell: ({ value }) => (
          <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
            <p>{value}</p>
          </div>
        ),
      },
    ],
    [page],
  );

  const markAsRead = async () => {
    if (!note) {
      toast.info("Please add notes");
      return;
    }
    let payload = {
      alert_id: id,
      notes: note,
    };
    let res = await post(URLS.PAYMENT_FAILED_MARK_AS_READ, payload);
    console.log("mark as read res", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      navigate(-1);
    }
  };

  let isRead = transactionData?.is_read;
  return (
    <div>
      <Topbar header={"Failed Transaction"} />

      <div
        onClick={() => navigate(-1)}
        style={{
          background: "#78788029",
          flexDirection: "row",
          alignItems: "center",
          display: "flex",
          width: "90px",
          padding: "10px",
          borderRadius: "10px",
          cursor: "pointer",
        }}
      >
        <div style={{ width: 25, height: 25 }}>
          <img
            src={CaretLeft}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </div>
        <p>Back</p>
      </div>

      <div
        style={{
          padding: "0 16px 14px",
          fontSize: 13,
          color: "#374151",
          fontSize: "18px",
          fontWeight: "600",
          marginTop: "20px",
        }}
      >
        Failed count : <strong>{transactionData?.failed_count}</strong>
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
          flex: 1,
          gap: 20,
          alignItems: "baseline",
        }}
      >
        <div style={{ width: "55%" }}>
          <Table
            columns={columns}
            setPageno={setPage}
            pagecount={pagination}
            data={transactionData?.transactions ?? []}
            show={false}
          />
        </div>

        <div style={{ width: "35%", transform: "translateY(-10px)" }}>
          <div
            style={{
              background: "#f3f4f6",
              borderRadius: "12px",
              padding: "1.5rem",
            }}
          >
            <h2
              style={{ fontSize: "16px", fontWeight: 500, margin: "0 0 1rem" }}
            >
              {"Notes"}
            </h2>

            <div
              style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: "12px 14px",
              }}
            >
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="No available balance in the account"
                rows={4}
                disabled={isRead}
                style={{
                  width: "100%",
                  border: "none",
                  outline: "none",
                  resize: "none",
                  fontSize: "14px",
                  color: isRead ? "#9ca3af" : "#111827",
                  background: "transparent",
                  fontFamily: "inherit",
                  boxSizing: "border-box",
                  cursor: "text",
                }}
              />
              <p style={{ fontSize: "12px", color: "#9ca3af", margin: 0 }}>
                {transactionData?.approved_by ?? name?.name} &nbsp;|&nbsp; ID:{" "}
                {transactionData?.admin_code ?? name?.admin_code}
              </p>
            </div>

            {!isRead && (
              <button
                style={{
                  marginTop: "1rem",
                  background: "#a78bfa",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px 22px",
                  fontSize: "14px",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
                onMouseOver={(e) => (e.target.style.background = "#7c3aed")}
                onMouseOut={(e) => (e.target.style.background = "#a78bfa")}
                onClick={() => markAsRead()}
              >
                Mark As Read
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
